import { CHART_THEME_COLORS } from "@/pages/CreatorAnalytics/constants";

export interface IChartThemeColors {
  text: string;
  gridline: string;
}

export const getChartColors = (isDark: boolean): IChartThemeColors => (isDark ? CHART_THEME_COLORS.dark : CHART_THEME_COLORS.light);
